import { SelectionList, Text } from '@dixa/lib-shared-habla';
import { memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { HookFormSelectionListSingle } from 'components/hookForm';
import {
  elevionArrayComparators,
  elevionBooleanComparators,
  ElevionComparator,
  elevionComparatorLabels,
  elevionDateComparators,
  elevionHtzComparators,
  ElevionLeafNode,
  elevionNumberComparators,
  elevionStringComparators,
  elevionTimeComparators,
} from 'utils/elevion';

import { AttributeFormFieldValues } from '../../../../../../../customAttributeModalForm.types';

export const fieldTypeComparatorMap = {
  bfield: elevionBooleanComparators,
  nfield: elevionNumberComparators,
  dfield: elevionDateComparators,
  sfield: elevionStringComparators,
  safield: elevionArrayComparators.filter(
    (comparator) => comparator !== 'contains_all',
  ),
  tfield: elevionTimeComparators,
  htzfield: elevionHtzComparators,
} as const;

type LeafComparatorFieldProps = {
  parentName: string;
};

/**
 * Renders a select containing list of supported comparators based on the
 * selected field.
 */
export const LeafComparatorField = memo(function LeafComparatorField({
  parentName,
}: LeafComparatorFieldProps): JSX.Element {
  // TODO: [TEAMS-13693] remove omit after updating to RHF v8
  const { control } =
    useFormContext<Omit<AttributeFormFieldValues, 'options'>>();
  const name = `${parentName}.comparator` as 'visibility_condition.comparator';
  const node = useWatch({
    control,
    name: parentName as 'visibility_condition',
  }) as ElevionLeafNode;
  const comparators = fieldTypeComparatorMap[node.field_type] ?? [];

  return (
    <HookFormSelectionListSingle
      name={name}
      control={control}
      noLabel
      noAlert
      componentProps={{
        getItemTitleByValue: (
          comparator: ElevionComparator | null | undefined,
        ) => {
          return (
            <Text.Paragraph>
              {comparator ? elevionComparatorLabels[comparator] : null}
            </Text.Paragraph>
          );
        },
        placeholder: 'Select a comparator',
      }}
    >
      {comparators.map((comparator) => (
        <SelectionList.Item key={comparator} value={comparator}>
          {elevionComparatorLabels[comparator]}
        </SelectionList.Item>
      ))}
    </HookFormSelectionListSingle>
  );
});
